import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";

import RouterWrapper from "wrappers/RouterWrapper";
import UserDataWrapper from "wrappers/UserDataWrapper";
import { ChakraProvider } from "@chakra-ui/react";

import CustomThemechakraUI from "utils/CustomThemechakraUI";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ChakraProvider theme={CustomThemechakraUI}>
    <UserDataWrapper>
      <RouterWrapper />
    </UserDataWrapper>
  </ChakraProvider>
);
